const cadastro_de_informacao_complementar_do_aluno = [
  {
    path: "/cadastro-de-informacao-complementar-do-aluno",
    redirect: "/cadastro_de_informacao_complementar_do_aluno",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/cadastro-de-informacao-complementar-do-aluno",
        name: "cadastro_de_informacao_complementar_do_aluno",
        component: () =>
          import(
            "@/views/CadastroDeInformacaoComplementarDoAluno/CadastroDeInformacaoComplementarDoAluno.vue"
          ),
      },
      {
        path: "/cadastro-de-informacao-complementar-do-aluno-novo",
        name: "cadastro_de_informacao_complementar_do_aluno_novo",
        component: () =>
          import(
            "@/views/CadastroDeInformacaoComplementarDoAluno/CadastroDeInformacaoComplementarDoAlunoCad.vue"
          ),
      },
      {
        path: "/cadastro-de-informacao-complementar-do-aluno-detalhes/:id",
        name: "cadastro-de-informacao-complementar-do-aluno-detalhes",
        component: () =>
          import(
            "@/views/CadastroDeInformacaoComplementarDoAluno/CadastroDeInformcaoComplementarDetalhe.vue"
          ),
      },
      {
        path: "/cadastro-de-informacao-complementar-do-aluno-cancelar/:id",
        name: "cadastro-de-informacao-complementar-do-aluno-cancelar",
        component: () =>
          import(
            "@/views/CadastroDeInformacaoComplementarDoAluno/CadastroDeInformcaoComplementarCancelar.vue"
          ),
      },
    ],
  },
];

export { cadastro_de_informacao_complementar_do_aluno };
